import React, { useRef } from 'react';
import ResizeObserver from 'rc-resize-observer';
import { AutoSizer, List, CellMeasurer, CellMeasurerCache } from 'react-virtualized';
import { ClauseSummaryCard } from '../../ClauseSummaryCard';

export default function ClauseList({ searchResults, flattenClauseGroups, headerHeight }) {
    const cache = useRef(
        new CellMeasurerCache({
            fixedWidth: true,
            defaultHeight: 300
        })
    );

    const renderRow = ({ index, key, style, parent }) => {
        return (
            <CellMeasurer
                key={key}
                cache={cache.current}
                parent={parent}
                columnIndex={0}
                rowIndex={index}
            >
                {({ measure }) => (
                    <div style={{ ...style, width: '100%' }}>
                        <ResizeObserver onResize={measure}>
                            <ClauseSummaryCard
                                key={searchResults[index]}
                                clauseId={searchResults[index]}
                                clause={flattenClauseGroups[searchResults[index]]}
                                isExpanded={true}
                                parentId={flattenClauseGroups[searchResults[index]].parent_id}
                                hideControls
                            />
                            <div style={{ marginBottom: 10 }} />
                        </ResizeObserver>
                    </div>
                )}
            </CellMeasurer>
        );
    };

    return (
        <AutoSizer>
            {({ height, width }) => (
                <List
                    width={width}
                    height={headerHeight ? height - headerHeight : height}
                    style={{ padding: '0 1.2rem', outline: 'none' }}
                    deferredMeasurementCache={cache.current}
                    rowHeight={cache.current.rowHeight}
                    rowRenderer={renderRow}
                    rowCount={searchResults.length}
                    overscanRowCount={5}
                />
            )}
        </AutoSizer>
    );
}
